module.exports = __webpack_public_path__ + "src/assets/img/light_turn_r.af7ff85b.svg";